import React, { Component } from 'react';
import Page from '../containers/page';
import {
    Col,
    Container, Row,

} from 'reactstrap';
import image from '../assets/images/account-cover.png';
import imageMobile from '../assets/images/account-cover.png';
import {getSearchParams} from "../helpers/linkHelper";
import {API_ENDPOINT} from "../constants";

class BriqpayPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            clientToken: null,
            status: null,
            sessionId: null
        };
    }
    get = () => {
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
            ).then((data) => {
                this.setState({
                    ...data,
                });
            });
        }

        let params = getSearchParams(this.props[0].location.search, {});

        if (this.props.loadDataWithQuery) {
            for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
                this.props.loadDataWithQuery[i](
                    window.fetch,
                    this.props.lang,
                    this.props[0].match,
                    params,
                    this.props[0].location.pathname,
                ).then((data) => {
                    localStorage.setItem('brigPaySession', data.sessionId);
                    this.setState(
                        {
                            ...data,
                            loading: null,
                        },
                        () => {
                            this.props.updateMeta(
                                this.props.generateSeoTags(this.state, this.props.lang),
                            );
                        },
                    );
                });
            }
        }

        this.props.updateMeta(
            this.props.generateSeoTags(this.state, this.props.lang),
        );
    };
    async componentDidMount() {
        if(localStorage.getItem('brigPaySession')) {
            localStorage.removeItem('brigPaySession');
        }
        await this.get(); // Assuming this is some async function you have
        this.setupBriqpayExample()

    }
    componentWillUnmount() {
        this.unsubscribeEvents();
    }
    unsubscribeEvents = () => {
        console.log('unsubscribeEvents')
        if(window._briqpay) {
            window._briqpay.unsubscribe('make_decision');
        }
    }
    subscribeToEvents = async () => {
        window._briqpay.subscribe('make_decision', async ({ sessionId }) => {
            if(sessionId) {
                await this.makeDecision(sessionId, 'allow')
                window._briqpay.v3.resumeDecision();
            }
        });

    }
    setupBriqpayExample = async () => {
        await  window._briqpay.v3.onReady(() => {
            console.log('BRIQPAY READY!')
        });
        this.subscribeToEvents();
    }
     makeDecision = async (sessionId, decision) => {
         await fetch(API_ENDPOINT + `/briqpay/make-decision/${sessionId}`, {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/json',
             },
             body: JSON.stringify({
                 decision
             }),
         })
             .then((res) => res.json())

    }
    saveBrigPayClient = (sessionId) => {
        fetch(API_ENDPOINT + `/briqpay/client-session-save/${sessionId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((res) => res.json())
    }
    render() {
        const iframeSrc = `https://msc-playground.briqpay.com?sessionToken=${this.state.clientToken}`;
        return (
            <div className="account-page">
                <section className="test">
                    <img
                        src={
                            typeof window !== 'undefined' && window.innerWidth < 768
                                ? imageMobile
                                : image
                        }
                    />
                    <div className="test-content">
                        <h1>{'BLI FÖRETAGSKUND'.translate(this.props.lang)}</h1>
                    </div>
                </section>

                <Container>
                    <Row style={{justifyContent: 'center', padding: '30px 0'}}>
                        <Col lg="12">
                            <div
                                className="account-container"
                                style={{textAlign: 'center'}}
                            >
                                <h3 style={{fontSize: 24, marginBottom: 10}}>
                                    {'SÅ HÄR GÅR DET TILL ATT HANDLA SOM FÖRETAG'.translate(this.props.lang)}
                                </h3>
                                <p className="sub-title">
                                    {'Just nu endast för svenska företag med leverans inom Sverige.'.translate(this.props.lang)}
                                </p>
                                <p style={{fontSize: 14}}
                                   dangerouslySetInnerHTML={{__html: 'Bli företagskund och handla direkt från Venture Design! Registreringen är enkel – fyll i företagets uppgifter nedan och få inloggningsuppgifter skickade till vald mejl. När ni har loggat in är det bara att börja shoppa! Betala smidigt med företagskort eller ansök om fakturabetalning – ni får svar direkt om det är möjligt att handla på faktura. Signering sker säkert med Bank-ID.'.translate(this.props.lang)}}/>

                            </div>
                        </Col>

                    </Row>
                </Container>
                <Container>
                    <Row>
                        <Col lg="6">
                            <div className="briqpay-container-left">
                                <h4>
                                    {'SOM FÖRETAGSKUND FÅR DU'.translate(this.props.lang)}:
                                </h4>
                                <ul>
                                    <li className="black-circle">
                                        {'Handla enkelt via företagskort eller ansök om faktura.*'.translate(this.props.lang)}
                                    </li>
                                    <li className="black-circle">
                                        {'Leverans inom 4-7 arbetsdagar.**'.translate(this.props.lang)}
                                    </li>
                                    <li className="black-circle">
                                        {'Fri frakt vid ordervärden från 7 500 kr'.translate(this.props.lang)}
                                    </li>
                                </ul>
                                <p> {'Om ordervärdet understiger detta tillkommer en fraktavgift på 499 kr.'.translate(this.props.lang)}</p>
                                <div className="note">
                                    <p>{'*14 dagar netto lämnas först efter godkänd kreditansökan'.translate(this.props.lang)}</p>
                                    <p>{'**Vi reserverar oss för eventuella fördröjda leveranstider vid hög belastning'.translate(this.props.lang)}</p>
                                </div>
                                <p className="bold-txt"
                                   dangerouslySetInnerHTML={{__html: 'Vill du istället bli återförsäljare av våra produkter'.translate(this.props.lang)}}/>

                            </div>
                        </Col>
                        <Col lg="6">
                            <div className="briqpay-container">
                                <h3>
                                    {'Företagsregistrering'.translate(this.props.lang)}
                                </h3>
                                <div id="briqpay-container" className="klarna-confirmation-iframe">
                                    <iframe id="briqpay-iframe" title="Checkout" scrolling="no" allow="payment"
                                            src={iframeSrc}>
                                    </iframe>
                                </div>

                            </div>
                        </Col>
                    </Row>
                            </Container>
            </div>
        );
    }
}

export default Page(BriqpayPage);
